import { Resource } from "@app/http/resource/resource.model";

// tslint:disable: variable-name
export class LogDataLayerSendEvent extends Resource {
  // id is inherited from Resource
  data_layer_objects: any;
  person_id: string;
  selective_process_id: number;
  button_id: number;
  stage_id: number;
  last_place_id: number;
  last_place_type_id: number;
}
